import { render, staticRenderFns } from "./StoryTable.vue?vue&type=template&id=612a4080"
import script from "./StoryTable.vue?vue&type=script&lang=js"
export * from "./StoryTable.vue?vue&type=script&lang=js"
import style0 from "./StoryTable.vue?vue&type=style&index=0&id=612a4080&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('612a4080')) {
      api.createRecord('612a4080', component.options)
    } else {
      api.reload('612a4080', component.options)
    }
    module.hot.accept("./StoryTable.vue?vue&type=template&id=612a4080", function () {
      api.rerender('612a4080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/FormStory/Components/StoryTable.vue"
export default component.exports